/**
 * this is the menu item component for the left and right menu
 *
 * Created by Tom on 28/5/18
 */

import React from 'react'
import PropTypes from 'prop-types'

import AppLink from '../AppLink/'
// icon imports
import LinkIcon from '../../assets/svg/newlink.svg'
import ArrowIcon from '../../assets/svg/arrow.svg'

// style import
import './style.scss'
import cx from "classnames";


const MenuItem = ({svgIcon, isExternal, openInNewTab, menuText, route, onClick, pathname, tourId, onTour, onTourHighlight}) => {

    const leftIconAltText = `Menu item left icon for ${menuText}`

    const dynClass = cx(
        'menu-item',
        {'menu-item--active': (route === pathname && onTour === false) || (onTour === true && onTourHighlight === menuText)},
        tourId
    )

    return (
        <AppLink
            isExternal={isExternal}
            onClick={onClick}
            route={route}
            openInNewTab={openInNewTab}
            className={dynClass}
        >
            <span className="menu-item__innerwrapper">
                {svgIcon &&
                <img src={svgIcon} className="menu-item__left-icon" alt={leftIconAltText}/>
                }
                <span className="menu-item__menu-text">{menuText}</span>
                {isExternal ?
                    <div className="menu-item__right-icon-container">
                        <img src={LinkIcon} className="menu-item__right-icon-container__right-icon-external"
                             alt="Avatar icon"/>
                    </div>
                    :
                    <img src={ArrowIcon} className="menu-item__right-icon" alt="Arrow icon"/>
                }
            </span>
        </AppLink>
    )
}

// define the prop types
MenuItem.propTypes = {
    svgIcon: PropTypes.string,
    isExternal: PropTypes.bool,
    menuText: PropTypes.string,
    onClick: PropTypes.func,
    pathname: PropTypes.string,
    openInNewTab: PropTypes.bool,
    tourId: PropTypes.string,
    onTour: PropTypes.bool,
    onTourHighlight: PropTypes.string
}

export default MenuItem



// WEBPACK FOOTER //
// ./src/components/MenuItem/index.js